import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Table } from "@renderbus/ui";
import { useGetInvoiceHistoryRecordTable } from "../hooks/useInitInvoiceHistoryRecordTable";
import MessageErrorIcon from "@/assets/icons/invoice/message-error";
import { Link } from "react-router-dom";
import { useInitHistoryRecordInfo } from "../hooks/useInitHistoryRecordInfo";

const InvoiceRecordWrapper = styled.div`
  padding: 30px 24px 20px;
  background-color: #222;
  height: calc(100vh - 116px);
`;
const InvoiceHistoryTip = styled.div`
  background-color: #333;
  line-height: 36px;
  padding: 0 15px;
  margin: 0 0 20px 0;
  border-radius: 4px;
  color: #ffffff;
  display: inline-flex;
  a {
    color: var(--main-color);
    cursor: pointer;
    padding-left: 4px;
  }
  svg {
    width: 20px;
    margin-right: 10px;
  }
`;

const InvoiceDescribleContent = styled.div`
  p {
    padding: 10px 10px 0px 0px;
    font-size: 12px;
    color: #999999;
  }
`;

export default function InvoiceHistory() {
  const { t } = useTranslation("invoice");
  const columns = useGetInvoiceHistoryRecordTable();
  const { invoiceHistoryRecordInfo, fetchInvoiceHistoryRecord } =
    useInitHistoryRecordInfo();
  const [currentPageNum, setCurrentPageNum] = useState(1);
  return (
    <InvoiceRecordWrapper>
      <InvoiceHistoryTip>
        <MessageErrorIcon />
        {t("invoice_history_tip")}
        <Link to={{ pathname: "/invoice" }}>{t("invoice_new_entry")}</Link>
      </InvoiceHistoryTip>
      <Table
        dataSource={invoiceHistoryRecordInfo.items}
        columns={columns}
        showQuickJumper={true}
        total={invoiceHistoryRecordInfo.total}
        defaultPageSize={10}
        paginationCurrent={currentPageNum}
        onPageNumChange={(key: number) => {
          setCurrentPageNum(key);
          fetchInvoiceHistoryRecord({ pageSize: 10, pageNo: key });
        }}
        className="invoice-history-table"
      />
      <InvoiceDescribleContent>
        <p>{t("invoice_invoice_tips_1")}</p>
        <p>{t("invoice_invoice_tips_2")}</p>
      </InvoiceDescribleContent>
    </InvoiceRecordWrapper>
  );
}
